import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useSalesChannel } from '@/api/sales-channels'
import { useWorkspace } from '@/api/workspace'
import { LoadingSkeleton } from '@/components/loading-skeleton'
import { SalesChannelArchiveActions } from '@/components/sales-channels/sales-channel-archive-actions'
import { SalesChannelForm } from '@/components/sales-channels/sales-channel-form'

// Sales Channel edit (UI-SCREENS S-02, #169), with archive / un-archive. Owner only; both are
// audited as `archive` by the API.
export const Route = createFileRoute('/w/$slug/channels/$channelId/edit')({
  component: EditSalesChannel,
  staticData: { breadcrumb: 'salesChannels.form.editTitle' },
})

function EditSalesChannel() {
  const { t } = useTranslation()
  const { slug, channelId } = Route.useParams()
  const workspace = useWorkspace(slug)
  const channel = useSalesChannel(slug, Number(channelId))

  if (workspace.data && workspace.data.role !== 'owner') {
    return <Navigate to="/w/$slug/channels/$channelId" params={{ slug, channelId }} replace />
  }

  return (
    <section className="flex flex-col gap-4">
      <h1 className="font-heading text-xl font-semibold">{t('salesChannels.form.editTitle')}</h1>
      {channel.isPending ? (
        <LoadingSkeleton variant="form" rows={4} />
      ) : channel.isError || !channel.data ? (
        <p role="alert" className="text-sm text-destructive">
          {t('errors.generic')}
        </p>
      ) : (
        <>
          <SalesChannelForm slug={slug} channel={channel.data} />
          <SalesChannelArchiveActions slug={slug} channel={channel.data} />
        </>
      )}
    </section>
  )
}
